<template>
  <div>
    <div class=" col">
      <div class="row mt-5 from-location">
        <div class="col">
          <span v-html="$t('shopfloor.stockChanges.explanation')"/>
        </div>
      </div>
      <div class="row mt-5 from-location">
        <div class="col">
          <h5> {{ $t('shopfloor.stockChanges.scanProduct') }}</h5>
        </div>
      </div>

      <div class="manual-barcode-input-bottom barcode-input">
        <form @submit.prevent="barcodeScanned(manualBarcode)">
          <label for="manual-barcode">{{ $t('shopfloor.unloadingPage.manualBarcode') }}</label>
          <div class="d-flex">
            <input type="text" id="manual-barcode" class="form-control" v-model="manualBarcode"/>
            <button class="btn btn-primary" type="submit">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';


export default {
  name: 'stock-location-change',
  components: {},
  data() {
    return {
      manualBarcode: '',
      progress: 0,
      stockChange: {
        fromLocation: null,
        product: null,
        toLocation: null,
        barcode: null
      },
      allLocationsOfProduct: [],
      selectedProduct: null,
      availableProducts: []
    };
  },
  computed: {
    ...mapGetters('users', [
      'getMeBasic'
    ]),
    ...mapGetters('locations', ['getLocations']),
    ...mapGetters(['getAPICompanyID']),
    ...mapGetters('incomingOrderProducts', ['getProducts']),
  },
  methods: {
    ...mapActions('unloading', [
      'checkIfBarcodeIsLocation',
      'saveCurrentUnload'
    ]),
    ...mapMutations('unloading', [
      'setCurrentUnload'
    ]),
    showSameLocationPopUp() {
      this.$swal({
        title: this.$root.$t('shopfloor.stockChanges.sameLocation.title'),
        text: this.$root.$t('shopfloor.stockChanges.sameLocation.message'),
        type: 'error',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$root.$t('shopfloor.stockChanges.sameLocation.button'),
        onClose: () => {
          this.openScanNewLocationModal();
        }
      });
    },
    async submitAction(barcode) {
      this.stockChange.toLocation = barcode;
      // Close the swal
      $('.swal2-cancel').first().click();
      this.$store.commit('setLoading', true);
      if (this.stockChange.fromLocation) {
        await this.moveStock();
      } else {
        await this.createStock();
      }
      this.progress = 0; // Reset progress
      this.stockChange.barcode = null;
      this.allLocationsOfProduct = [];
      this.$store.commit('setLoading', false);
    },
    async handleScannedProduct(product, barcode) {
      this.$store.commit('setLoading', true);
      const res = await this.$CLOUD_API.get(`/locations/${product.id}/locations`, {
        params: {
          productId: product.id
        }
      });

      this.allLocationsOfProduct = res.data;
      this.stockChange.barcode = barcode;
      this.stockChange.product = product;
      this.$store.commit('setLoading', false);
      if (this.allLocationsOfProduct.length) {
        let modalhtml = `${this.$root.$t('shopfloor.stockChanges.productScannedModal.scannedProductNumber', { productNumber: barcode, stock: _.sumBy(this.allLocationsOfProduct, 'stock')})}<br/>`;
        modalhtml += `<select class="swal2-select" id="location-selector" style="width: 100%;">`;
        modalhtml += `<option value="" disabled selected>${this.$root.$t('whatDoYouWantToDo')}</option>`;
        this.allLocationsOfProduct.forEach(location => {
          const locationName = `${location.name} (${location.stock})`;
          modalhtml += `<option value="${location.locationId}">${this.$root.$t('shopfloor.stockChanges.productScannedModal.moveLocation', { location: locationName })}</option>`;
        });
        modalhtml += `<option class="alert-option" value="null">${this.$root.$t('shopfloor.stockChanges.productScannedModal.createStock')}</option>`;
        modalhtml += `</select>`;
        const global = this;
        const swalResult = await this.$swal({
          title: this.$root.$t('shopfloor.stockChanges.productScannedModal.title'),
          html: modalhtml,
          type: this.allLocationsOfProduct && this.allLocationsOfProduct.length > 0 ? '' : 'warning',
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: this.$root.$t('shopfloor.stockChanges.productScannedModal.cancel'),
          confirmButtonText: this.$root.$t('shopfloor.stockChanges.productScannedModal.next'),
          onOpen: () => {
            if (!this.stockChange.fromLocation) {
              $('.swal2-confirm').first().prop('disabled', true);
            }

            $('#location-selector').change(function (e) {
              const selectedLocationId = $(this).val();
              global.stockChange.fromLocation = selectedLocationId === 'null' ? null  : selectedLocationId;
              $('.swal2-confirm').first().prop('disabled', false);
            });
          },
        });
        if (swalResult.value) {
          await this.$store.dispatch('initDataForPage', [{
            module: 'incomingOrderProducts',
            where: ['productNumber', '==', this.stockChange.barcode]
          }]);
          return this.openScanNewLocationModal();
        } else {
          this.progress = 0; // Reset progress => due cancel press
          this.stockChange.barcode = null;
        }
      } else {
        await this.$store.dispatch('initDataForPage', [{
          module: 'incomingOrderProducts',
          where: ['productNumber', '==', this.stockChange.barcode]
        }]);
        this.stockChange.fromLocation = null;
        return this.openScanNewLocationModal();
      }
    },
    showWrongScanStep() {
      this.$swal({
        title: this.$root.$t('shopfloor.stockChanges.barcodeInsteadOfLocation.title'),
        text: this.$root.$t('shopfloor.stockChanges.barcodeInsteadOfLocation.message'),
        type: 'error',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$root.$t('shopfloor.stockChanges.barcodeInsteadOfLocation.button'),
        onClose: () => {
          this.openScanNewLocationModal();
        }
      });
    },
    showUnknownBarcodePopUp() {
      this.$swal({
        title: this.$root.$t('shopfloor.stockChanges.unknownBarcode.title'),
        text: this.$root.$t('shopfloor.stockChanges.unknownBarcode.message'),
        type: 'error',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$root.$t('shopfloor.stockChanges.unknownBarcode.button'),
      });
    },
    async barcodeScanned(barcode) {
      const isLocation = await this.checkIfBarcodeIsLocation(barcode);
      if (isLocation && this.progress !== 0 && `${this.stockChange.fromLocation}` === `${barcode}`) {
        this.showSameLocationPopUp();
      } else if (isLocation && this.progress !== 0) {
        await this.submitAction(barcode);
      } else {
        const product = await this.getProductFromBarcode(barcode);
        console.log("product", product, this.progress)
        if (product && this.progress === 0) {
          await this.handleScannedProduct(product, barcode);
        } else if (product && this.progress > 0) {
          this.showWrongScanStep();
        } else {
          this.showUnknownBarcodePopUp();
        }
      }
    },
    async openScanNewLocationModal() {
      this.progress = 1; // Set progress to the next step: scan location
      const blinkingIcon = '<div style="text-align: center; animation: blink 5s infinite; font-size: 8rem;" class="truck-icon"><span class="far fa-barcode-read"></span></div>';
      const swalResult = await this.$swal({
        title: this.$root.$t('shopfloor.stockChanges.scanNewLocationModal.title'),
        html: (this.allLocationsOfProduct.length ? this.$root.$t('shopfloor.stockChanges.scanNewLocationModal.message') : `<div class="alert-text">${this.$root.$t('shopfloor.stockChanges.scanNewLocationModal.messageNoStock')}</div>` ) + '<br/><br/>' + blinkingIcon,
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$root.$t('shopfloor.stockChanges.scanNewLocationModal.cancel'),
      });
      if (!swalResult.value) {
        this.progress = 0;
        this.stockChange.barcode = null;
      }
    },
    async getProductFromBarcode(barcode) {
      const productResult = await this.$FB
          .collection('products')
          .where('companyId', '==', parseInt(this.getAPICompanyID))
          .where('productNumber', '==', barcode ? barcode : 0)
          .get();
      if (productResult.empty) {
        return null; // No product with this barcode
      } else {
        return productResult.docs[0].data();
      }
    },
    async checkIfProductPresentInUnloadingCargo(barcode) {
      let product;
      let products = _.filter(this.getProducts, product => {
        // check if amount isnt already loaded fully
        return product.productNumber == barcode;
      });
      if (products.length) {
        product = _.find(products, p => {
          return (p.amountUnloaded ? p.amountUnloaded : 0) < p.amount
        })
        if (!product) {
          product = products[0]
        }
      }
      return product;
    },
    resetProgress() {
      this.stockChange = {
        fromLocation: null,
        product: null,
        amount: 1,
        toLocation: null,
        barcode: null
      };
      this.progress = 0;
      this.allLocationsOfProduct = [];
      this.availableProducts = [];
      this.selectedProduct = null;
    },
    async createStock() {
      let product = await this.checkIfProductPresentInUnloadingCargo(this.stockChange.product.productNumber);
      if (product && product.estimatedTimeOfArrival) {
        product.estimatedTimeOfArrival = product.estimatedTimeOfArrival.toDate();
      }
      const newStock = {
        startTime: new Date(),
        barcode: this.stockChange.product.productNumber,
        product: product,
        barcodeUnreadable: false,
        locationId: parseInt(this.stockChange.toLocation),
        userId: this.getMeBasic.userId,
        userName: this.getMeBasic.userName,
        companyId: this.getMeBasic.companyId,
        amount: product ? product.amount : 1,
        endTime: new Date(),
        trigger: 'stockChangePage'
      };
      const res = await this.$CLOUD_API.post('/locations/stock-create', newStock);
      this.resetProgress();
      if (res.status === 200) {
        this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          type: 'success',
          title: this.$root.$t('shopfloor.stockChanges.stockCreatedResult.success')
        });
      } else {
        this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          type: 'error',
          title: this.$root.$t('shopfloor.stockChanges.stockCreatedResult.error')
        });
      }
      return res;
    },
    async moveStock() {
      const upload = {
        fromLocation: {
          id: parseInt(this.stockChange.fromLocation)
        },
        toLocation: {
          id: parseInt(this.stockChange.toLocation)
        },
        product: {
          productId: this.stockChange.product.id
        },
        companyId: this.getAPICompanyID,
        amount: 1,
        barcode: this.stockChange.barcode,
        userId: this.getMeBasic.userId,
        userName: this.getMeBasic.userName
      };
      const res = await this.$CLOUD_API.put('/locations/stock-change', upload, upload);
      this.resetProgress();
      if (res.status === 200) {
        this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          type: 'success',
          title: this.$root.$t('shopfloor.stockChanges.locationMovementResult.success')
        });
      } else {
        this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          type: 'error',
          title: this.$root.$t('shopfloor.stockChanges.locationMovementResult.error')
        });
      }
      return res;
    }
  },
  watch: {},
  async beforeRouteLeave(from, to, next) {
    this.progress = 0;
    this.allLocationsOfProduct = [];
    await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
    await this.$store.dispatch('resetStoreModules', ['incomingOrderProducts']);
    next();
  },

  created() {
    this.progress = 0;
    this.allLocationsOfProduct = [];
    this.$barcodeScanner.barCodeEventBus.$on('barcodeScanned', this.barcodeScanned);
  }
};
</script>

<style>
.alert-option, .alert-text {
  color: #d88c00;
}


</style>
<style lang="scss" scoped>

.opac {
  opacity: 0.5;
}

.input-group-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: .375rem .75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: .25rem;
}

.manual-barcode-input-bottom {
  position: fixed;
  bottom: 1rem;
  width: 90%;
  left: 5%;
}


</style>
